// extracted by mini-css-extract-plugin
export default {"products":"bw-z","card":"cw-z","oosMessaging":"dw-z"};